import { ContainerHeight } from '@storage/app/api'
import { SelectOption } from '@storage/app/models'
import { EnumAsSelectOptionsUtil } from '@storage/utils/enums'
import { useMemo } from 'react'

const KEY_PREFIX = 'containerHeight'

export const useContainerHeightOptions = (): SelectOption[] =>
  useMemo(
    () =>
      EnumAsSelectOptionsUtil.transform(ContainerHeight, KEY_PREFIX).map(option => ({
        ...option,
        label: option.label,
      })),
    [],
  )
